import { render, staticRenderFns } from "./contractManage.vue?vue&type=template&id=535c0348&scoped=true&"
import script from "./contractManage.vue?vue&type=script&lang=js&"
export * from "./contractManage.vue?vue&type=script&lang=js&"
import style0 from "./contractManage.vue?vue&type=style&index=0&id=535c0348&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535c0348",
  null
  
)

export default component.exports